export interface WebinarCashPayment {
  callOutcome?: string;
  cashCollected?: number;
}

/**
 * Upfront cash is every cash-collected EOC payment except an explicit MRR row.
 * Overall cash includes those MRR payments as well.
 */
export function calculateWebinarCashRoas(payments: WebinarCashPayment[]): {
  upfrontCash: number;
  totalCash: number;
} {
  let upfrontCash = 0;
  let totalCash = 0;

  for (const payment of payments) {
    const cash = payment.cashCollected || 0;
    totalCash += cash;
    if ((payment.callOutcome || "").trim().toLowerCase() !== "mrr") {
      upfrontCash += cash;
    }
  }

  return { upfrontCash, totalCash };
}

export function formatWebinarRoasCashAmounts(cash: number, adSpend: number): string {
  const formatCompactCurrency = (value: number) =>
    value >= 1_000 ? `$${(value / 1_000).toFixed(1)}K` : `$${value.toFixed(0)}`;

  return `${formatCompactCurrency(cash)} / ${formatCompactCurrency(adSpend)}`;
}
